import React from "react";
import { format } from "date-fns";

import { Chip } from "@mui/material";

import DataTable from "../../../common/DataTable";
import ColumnHeader from "../../../common/ColumnHeader";

import { getChipColor } from "../../../../constants/value";
import { dateSortComparator } from "../../../../utils/date";

const TmobilejOrderInfoList = ({
  data,
  meta,
  client,
  loading,
  handlePageChange,
  handlePageSizeChange,
  handleRowClick,
  handleColumnClick,
}) => {
  const columns = [
    { field: "id", headerName: "ID", flex: 1, sortable: false },
    {
      field: "status",
      headerName: "Status",
      minWidth: 100,
      flex: 2,
      renderCell: (params) => (
        <Chip
          label={params.row.status}
          size="small"
          color={getChipColor(params.row.status)}
        />
      ),
      sortable: false,
      renderHeader: (params) =>
        client ? (
          <ColumnHeader
            label={"Status"}
            handleClick={() => handleColumnClick("status")}
          />
        ) : (
          "Status"
        ),
    },
    {
      field: "order_id",
      headerName: "Order ID",
      minWidth: 200,
      flex: 2,
      sortable: false,
      renderHeader: (params) =>
        client ? (
          <ColumnHeader
            label={"Order ID"}
            handleClick={() => handleColumnClick("order_id")}
          />
        ) : (
          "Order ID"
        ),
    },
    {
      field: "order_status",
      headerName: "Order Status",
      minWidth: 150,
      flex: 2,
      sortable: false,
      renderCell: (params) =>
        params.row.order_status ? (
          <Chip
            label={params.row.order_status}
            size="small"
            color={getChipColor(params.row.order_status)}
          />
        ) : (
          "-"
        ),
      renderHeader: (params) =>
        client ? (
          <ColumnHeader
            label={"Order Status"}
            handleClick={() =>
              handleColumnClick && handleColumnClick("order_status")
            }
          />
        ) : (
          "Order Status"
        ),
    },
    {
      field: "order_date",
      headerName: "Order Date",
      minWidth: 200,
      flex: 2,
      sortable: false,
      valueGetter: (params) => params.row.order_date || null,
      valueFormatter: (params) =>
        params.value &&
        `${format(new Date(params.value), "MMMM d, y hh:mm a")}`,
      sortComparator: dateSortComparator,
    },
    {
      field: "order_type",
      headerName: "Order Type",
      minWidth: 150,
      flex: 2,
      sortable: false,
      renderHeader: (params) =>
        client ? (
          <ColumnHeader
            label={"Order Type"}
            handleClick={() =>
              handleColumnClick && handleColumnClick("order_type")
            }
          />
        ) : (
          "Order Type"
        ),
    },
    {
      field: "order_status_message",
      headerName: "Order Message",
      minWidth: 200,
      flex: 3,
      sortable: false,
      renderHeader: (params) =>
        client ? (
          <ColumnHeader
            label={"Order Message"}
            handleClick={() =>
              handleColumnClick && handleColumnClick("order_status_message")
            }
          />
        ) : (
          "Order Message"
        ),
    },
    {
      field: "created_at",
      headerName: "Created At",
      minWidth: 200,
      filterable: false,
      flex: 2,
      sortable: false,
      valueGetter: (params) => params.row.created_at || null,
      valueFormatter: (params) =>
        params.value &&
        `${format(new Date(params.value), "MMMM d, y hh:mm a")}`,
      sortComparator: dateSortComparator,
    },
    {
      field: "last_updated",
      headerName: "Last Updated",
      minWidth: 200,
      filterable: false,
      flex: 2,
      sortable: false,
      valueGetter: (params) => params.row.last_updated || null,
      valueFormatter: (params) =>
        params.value &&
        `${format(new Date(params.value), "MMMM d, y hh:mm a")}`,
      sortComparator: dateSortComparator,
    },
  ];

  return (
    <DataTable
      disableColumnFilter
      loading={loading}
      data={data}
      client={client}
      getRowId={(row) => row.id}
      columns={
        client ? columns.map((val) => ({ ...val, sortable: true })) : columns
      }
      metaData={meta}
      handleRowClick={handleRowClick}
      handlePageChange={handlePageChange}
      handlePageSizeChange={handlePageSizeChange}
    />
  );
};

export default TmobilejOrderInfoList;
